import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output,
  Renderer2,
  inject,
  input,
  signal,
} from '@angular/core';
import { Rect } from '../../classes/rect.class';

@Directive({
  selector: '[appClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective implements OnDestroy {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  exceptionElementNames = input<string[]>();
  @Output() onClickOutside: EventEmitter<void> = new EventEmitter();
  unsubscribeClick: () => void;
  unsubscribePointerDown: () => void;
  private readonly startPosition = signal<Rect>(undefined);

  private getParentTill(el: HTMLElement, checkFor: HTMLElement) {
    if (el === checkFor) return true;
    if (!el.parentElement) return false;
    return this.getParentTill(el.parentElement, checkFor);
  }

  private getParentTillElementNames(el: HTMLElement, names: string[]) {
    if (names.includes(el.nodeName.toLowerCase())) return true;
    if (!el.parentElement) return false;
    return this.getParentTillElementNames(el.parentElement, names);
  }

  pointerDown(e: PointerEvent) {
    this.startPosition.set(Rect.fromMouseEvent(e));
  }

  private click(e: PointerEvent) {
    const currentPosition = Rect.fromMouseEvent(e);
    if (currentPosition && this.startPosition()) {
      const delta = currentPosition.subtract(this.startPosition()).magnitude();
      if (delta > 10) return;
    }
    this.startPosition.set(undefined);
    if (this.getParentTill(<HTMLElement>e.target, this.elementRef.nativeElement)) return;
    if (
      this.exceptionElementNames() &&
      this.getParentTillElementNames(<HTMLElement>e.target, this.exceptionElementNames())
    )
      return;
    this.onClickOutside.emit();
  }

  constructor() {
    setTimeout(() => {
      this.unsubscribePointerDown = this.renderer.listen('window', 'pointerdown', (e: PointerEvent) => {
        this.pointerDown(e);
      });
      this.unsubscribeClick = this.renderer.listen('window', 'click', (e: PointerEvent) => {
        this.click(e);
      });
    });
  }

  ngOnDestroy() {
    this.unsubscribeClick?.();
    this.unsubscribePointerDown?.();
  }
}
